import { useNavigate } from '@tanstack/react-router';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { Logo } from '@/components/atoms/Logo';
import { Button } from '@/components/ui/button';
import { APP_ROUTES } from '@/const/routes';

export const ErrorPage = ({ error }: ErrorComponentProps) => {
  const navigate = useNavigate();

  const message =
    error instanceof Error ? error.message : 'Sorry, an unexpected error has occurred.';

  return (
    <div className="bg-primary min-h-screen flex flex-col text-primary-foreground">
      <Logo
        imageVariant="black"
        logoClassName="size-8 absolute top-4 left-4"
        showText={false}
      />

      <div className="flex-1 flex flex-col items-center justify-center gap-6 text-center px-4">
        <p className="text-7xl font-syne font-bold">Oops!</p>
        <div className="space-y-2">
          <p className="text-2xl font-semibold">Something went wrong</p>
          <p className="text-primary-foreground/70 max-w-sm">{message}</p>
        </div>
        <Button
          className="bg-foreground text-background hover:bg-foreground/90"
          onClick={() => navigate({ to: APP_ROUTES.index })}
        >
          Go to home page
        </Button>
      </div>
    </div>
  );
};
